<template lang="">
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Start Introduction Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
<div class="intro-section doc-wrapper">
    <div class="row">
        <div class="col-xl-12">
            <div class="intro-wrapper">
                <h1 class="site-title"><span>eFunding</span> - Crowdfunding Platform Android and iOS App | Website | Admin Panel</h1>
                <p><span class="text--base">eFunding</span> is a cutting-edge crowdfunding platform that empowers entrepreneurs, non-profit organizations, and individuals to achieve their fundraising goals with ease and efficiency. With a comprehensive suite of Android and iOS apps, a user-friendly website, and an intuitive admin panel, eFunding provides a seamless crowdfunding experience for both campaigners and donors. eFunding is the go-to crowdfunding marketplace that brings together campaigners and donors in a seamless and secure environment. Whether you're a budding entrepreneur, a passionate advocate, or a nonprofit organization, eFunding provides the tools and resources to transform your ideas into reality.</p>
                
            </div>
        </div>
    </div>
</div>
<div class="page-change-area">
    <div class="navigation-wrapper">
        <router-link :to="{ name: 'ServerSetupRequirements'}" class="right">Server Setup Requirements <i class="las la-angle-right ms-1"></i></router-link>
    </div>
</div>
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    End Introduction Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
</template>
<script>
export default {
    name: 'WelcomePage',
}
</script>